/**
 * Offer utilities
 */

const API_BASE_URL = process.env.REACT_APP_API_URL || '/api';

const getStoredToken = () => {
  return localStorage.getItem('auth_token');
};

export const getOffers = async (filters = {}) => {
  try {
    const token = getStoredToken();
    if (!token) {
      return { data: null, error: { message: 'Not authenticated' } };
    }

    const params = new URLSearchParams();
    if (filters.request_id) params.append('request_id', filters.request_id);
    if (filters.seller_id) params.append('seller_id', filters.seller_id);

    const response = await fetch(`${API_BASE_URL}/offers?${params}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
      },
    });

    const data = await response.json();

    if (!response.ok) {
      return { data: null, error: { message: data.error || 'Failed to fetch offers' } };
    }

    return { data: data.data || [], error: null };
  } catch (error) {
    return { data: null, error: { message: error.message || 'Network error' } };
  }
};

export const createOffer = async (offerData) => {
  try {
    const token = getStoredToken();
    if (!token) {
      return { data: null, error: { message: 'Not authenticated' } };
    }

    const response = await fetch(`${API_BASE_URL}/offers`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
      },
      body: JSON.stringify(offerData),
    });

    const data = await response.json();

    if (!response.ok) {
      return { data: null, error: { message: data.error || 'Failed to create offer' } };
    }

    return { data: data.data, error: null };
  } catch (error) {
    return { data: null, error: { message: error.message || 'Network error' } };
  }
};

export const acceptOffer = async (offerId) => {
  try {
    const token = getStoredToken();
    if (!token) {
      return { data: null, error: { message: 'Not authenticated' } };
    }

    const response = await fetch(`${API_BASE_URL}/offers/${offerId}/accept`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
      },
    });

    const data = await response.json();

    if (!response.ok) {
      return { data: null, error: { message: data.error || 'Failed to accept offer' } };
    }

    return { data: data.data, error: null };
  } catch (error) {
    return { data: null, error: { message: error.message || 'Network error' } };
  }
};

